import { render, staticRenderFns } from "./CreativeVelocity.vue?vue&type=template&id=b56c7b90&scoped=true"
import script from "./CreativeVelocity.vue?vue&type=script&lang=js"
export * from "./CreativeVelocity.vue?vue&type=script&lang=js"
import style0 from "./CreativeVelocity.vue?vue&type=style&index=0&id=b56c7b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c7b90",
  null
  
)

export default component.exports